import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';
import { catchError, from, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (request, next) => {

  const router = inject(Router);

  //console.log('intercepted request', request);

  return from(fetchAuthSession()).pipe(
    switchMap((auth: any) => {
      //console.log("session", auth) ;
      if (!auth.tokens?.idToken) {
        return next(request);
      }

      const jwt: string = auth.tokens.idToken.toString();
      //console.log("jwt", jwt) ;
      const authRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${jwt}`,
        },
      });
      
      return next(authRequest);
    }),
    catchError((err:any) => {

      if (err instanceof HttpErrorResponse) {
        if (err.status == 401) {
          router.navigate(['signin']);
        }
      }
      
      return next(request);
      //return throwError(() => new Error(err));
    })
  )
};
